import React from "react";

function Header({
  view,
  changeView,
}: {
  view: string;
  changeView: React.Dispatch<React.SetStateAction<string>>;
}) {
  return (
    <div className="flex text-white text-2xl mb-8 items-center justify-center font-medium pointer-events-auto">
      <div
        className={
          view === "swap"
            ? "bg-white text-black py-2 px-6 m-4 rounded-sm cursor-default"
            : "py-2 px-6 m-4 cursor-pointer"
        }
        onClick={() => changeView("swap")}
      >
        Swap
      </div>
      <div
        className={
          view === "balance"
            ? "bg-white text-black py-2 px-6 m-4 rounded-sm cursor-default"
            : "py-2 px-6 m-4 cursor-pointer"
        }
        onClick={() => changeView("balance")}
      >
        Balance
      </div>
      <div
        className={
          view === "liquidity"
            ? "bg-white text-black py-2 px-6 m-4 rounded-sm cursor-default"
            : "py-2 px-6 m-4 cursor-pointer"
        }
        onClick={() => changeView("liquidity")}
      >
        Liquidity
      </div>
    </div>
  );
}

export default Header;
